import { parseFailedPolicies } from 'Services';
import { PolicyRequirement } from '@forgerock/javascript-sdk';

export const mapFailedPoliciesToMessage = (failedPolicies: PolicyRequirement[]): string[] =>
  parseFailedPolicies(failedPolicies).map(mapFailedPolicyToMessage);

export const mapFailedPolicyToMessage = (failedPolicies: PolicyRequirement): string => {
  switch (failedPolicies.policyRequirement) {
    case 'VALID_EMAIL_ADDRESS_FORMAT':
      return `L'adresse e-mail saisie n'est pas valide`;
    case 'VALID_PHONE_FORMAT':
      return `Le numéro de téléphone fourni est invalide`;
    case 'DEFAULT':
    default:
      return `Le champ renseigné est incorrect`;
  }
};
